import { render, staticRenderFns } from "./transfer-lead-form.vue?vue&type=template&id=4644994a&"
import script from "./transfer-lead-form.vue?vue&type=script&lang=js&"
export * from "./transfer-lead-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports